import React from 'react';
import {
  Block,
  BlockProduct,
  BlockProductListSkeleton,
} from '@views/components/block/Block';

export const Placeholder = () => (
  <Block isSection>
    <BlockProduct v3>
      <BlockProduct.Body>
        <BlockProduct.List>
          <BlockProductListSkeleton number={6} />
        </BlockProduct.List>
      </BlockProduct.Body>
    </BlockProduct>
  </Block>
);

export default Placeholder;
